export {
  getStaticProps,
  LandingMobileApp as default,
} from '@cinch-nx/landing/feature-mobile-app'
